@if (visible()) {
  <div class="cookie-consent" role="dialog" aria-label="Süti tájékoztató">
    <div class="cookie-consent__inner">
      <p class="cookie-consent__text">
        A weboldal sütiket használ a működéshez és a felhasználói élmény javításához.
        Részletek az
        <a routerLink="/adatvedelmi-nyilatkozat">adatvédelmi nyilatkozatban</a>.
      </p>
      <button mat-raised-button class="btn-primary cookie-consent__btn" (click)="accept()">
        Elfogadom
      </button>
    </div>
  </div>
}
